const STORAGE_KEY = 'glanzgarage:wishlist';
const CHANGE_EVENT = 'wishlist:change';
function readWishlist() {
try {
const raw = localStorage.getItem(STORAGE_KEY);
const parsed = raw ? JSON.parse(raw) : [];
return Array.isArray(parsed) ? parsed : [];
} catch (error) {
return [];
}
}
function writeWishlist(handles) {
localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handles } }));
}
function isInWishlist(handle) {
return readWishlist().indexOf(handle) !== -1;
}
function toggleWishlist(handle) {
const handles = readWishlist();
const index = handles.indexOf(handle);
if (index === -1) {
handles.push(handle);
} else {
handles.splice(index, 1);
}
writeWishlist(handles);
return index === -1;
}
class WishlistButton extends HTMLElement {
connectedCallback() {
this.button = this.querySelector('button');
this.handle = this.dataset.productHandle;
this.updateState();
this.onClick = this.onClick.bind(this);
this.button.addEventListener('click', this.onClick);
this.onChange = this.updateState.bind(this);
document.addEventListener(CHANGE_EVENT, this.onChange);
}
disconnectedCallback() {
document.removeEventListener(CHANGE_EVENT, this.onChange);
}
onClick(event) {
event.preventDefault();
toggleWishlist(this.handle);
this.updateState();
}
updateState() {
const active = isInWishlist(this.handle);
this.classList.toggle('is-active', active);
if (this.button) {
this.button.setAttribute('aria-pressed', String(active));
const label = active ? this.dataset.labelRemove : this.dataset.labelAdd;
if (label) {
this.button.setAttribute('aria-label', label);
}
}
}
}
class WishlistCount extends HTMLElement {
connectedCallback() {
this.update = this.update.bind(this);
this.update();
document.addEventListener(CHANGE_EVENT, this.update);
}
disconnectedCallback() {
document.removeEventListener(CHANGE_EVENT, this.update);
}
update() {
const count = readWishlist().length;
this.textContent = String(count);
this.hidden = count === 0;
}
}
if (!customElements.get('wishlist-button')) {
customElements.define('wishlist-button', WishlistButton);
}
if (!customElements.get('wishlist-count')) {
customElements.define('wishlist-count', WishlistCount);
}
window.GlanzGarageWishlist = {
readWishlist: readWishlist,
writeWishlist: writeWishlist,
isInWishlist: isInWishlist,
toggleWishlist: toggleWishlist,
CHANGE_EVENT: CHANGE_EVENT
};
